import React from 'react';
import { Award, Clock, Users, Shield, DollarSign, Zap } from 'lucide-react';
import CounterAnimation from './CounterAnimation';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: Award,
      title: 'Success Rate',
      statNum: 98,
      statSuffix: '%',
      description: 'Our expert team achieves one of the highest trademark approval rates in the industry'
    },
    {
      icon: Clock,
      title: 'Fast Processing',
      description: 'Average 24-48 hour turnaround for application preparation and filing'
    },
    {
      icon: Users,
      title: 'Clients',
      statNum: 10000,
      statSuffix: '+',
      description: 'Trusted by thousands of businesses from startups to Fortune 500 companies'
    },
    {
      icon: Shield,
      title: 'Money-Back Guarantee',
      description: 'If we find your trademark is already taken, we provide a full refund'
    },
    {
      icon: DollarSign,
      title: 'Transparent Pricing',
      description: 'No hidden fees. You only pay what we quote upfront plus USPTO fees'
    },
    {
      icon: Zap,
      title: 'AI-Powered Search',
      description: 'Advanced technology scans millions of trademarks in seconds for conflicts'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Why Choose TrademarkPro?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We combine cutting-edge technology with expert legal knowledge to protect your brand
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-14 h-14 bg-[#FF6B35] rounded-lg flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
                <benefit.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-black mb-3">
                {benefit.statNum ? (
                  <>
                    <CounterAnimation 
                      end={benefit.statNum} 
                      suffix={benefit.statSuffix || ''} 
                    />{' '}
                    {benefit.title}
                  </>
                ) : (
                  benefit.title
                )}
              </h3>
              <p className="text-gray-600">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;